<template>
	<!-- 客户应急保电订单列表 -->
	<layout activeLabel="应急保电">
		<div class="btnGroup">
			<div class="btnTab" @click="statusChange(item)" :class="item.label == activeTab ? 'active' : ''"
				v-for="(item,index) in tabs" :key="index">
				{{item.label}}
				({{item.status==null?buttonSize.khyjnull
					:item.status==0?buttonSize.khyj0
					:item.status==71?buttonSize.khyj71
							:item.status==1?buttonSize.khyj1
									:item.status==2?buttonSize.khyj2
											:item.status==3?buttonSize.khyj3
													:item.status==4?buttonSize.khyj4
															:item.status==5?buttonSize.khyj5
																	:item.status==6?buttonSize.khyj6
																			:item.status==7?buttonSize.khyj7
																							:item.status==11?buttonSize.khyj11
																									:item.status==18?buttonSize.khyj18
																											:item.status==28?buttonSize.khyj28
																													:item.status==29?buttonSize.khyj29
																															:item.status==8?buttonSize.khyj8
																																	:item.status==9?buttonSize.khyj9
																																			:item.status==60?buttonSize.khyj60
																					:item.status==70?buttonSize.khyj70:0
				}})
			</div>
		</div>
		<div class="btnGroup">

			<el-input v-model="queryParams.projectname" placeholder="请输入工程名称" clearable @keyup.enter.native="getOrderList1"
								style="width: 200px;" />
			<el-button type="primary" plain style="margin-left: 10px;" @click="getOrderList1">查询
			</el-button>

		</div>
		<div class="deviceTable">
			<el-table :data="tableData" stripe>
				<el-table-column align="center" type="index" label="序号" :index="count" width="80"></el-table-column>
				<el-table-column align="center" label="订单名称" width="300">
					<template scope="{row}">
						<span>{{row.vArray == 2 ? row.orderNo + '合并订单' : row.orderNo }}</span>
						<span v-if="row.status == 60">(续)</span>
					</template>
				</el-table-column>
				<el-table-column label="工程名称" align="center" prop="projectname" />
				<el-table-column align="left" label="厂家名称" prop="companyName" show-overflow-tooltip></el-table-column>
				<el-table-column align="center" label="开始时间" prop="startTime"></el-table-column>
				<el-table-column align="center" label="订单价格">
					<template slot-scope="scope">
						<span>{{scope.row.advance}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="租赁时长" prop="name">
					<template slot-scope="scope">
						<div class="time-line">
							<div class="count">{{scope.row.advanceDate}}天</div>
							<!-- <div class="time">2020/12/12结束</div> -->
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="当前状态" prop="desc">
					<template slot-scope="scope">
 <span>
            {{scope.row.orderSatus == 0 ? '未确认提交': scope.row.orderSatus == 1 ? '待厂商确认' : scope.row.orderSatus == 2 ? '待平台签约'
		 : scope.row.orderSatus == 3 ? '待客户支付租金' : scope.row.orderSatus == 4 ? '待厂商确认收款并发货'
				 : scope.row.orderSatus == 6 ? '待客户收货'
						 : scope.row.orderSatus == 7 ? '待厂商确认用电完成' : scope.row.orderSatus == 11 ? '待客户确认用电完成'
								 : scope.row.orderSatus == 18 ? '待平台出具结算单' : scope.row.orderSatus == 28 ? '待厂商结算'
										 : scope.row.orderSatus == 29 ? '待客户收款': scope.row.orderSatus == 8 ? '已完成'
												 : scope.row.orderSatus == 9 ? '已评价': scope.row.orderSatus == 60 ? '待厂商确认续费'
														 : scope.row.orderSatus == 70 ? '中止订单':'其他'
	 }}
          </span>
						<span v-if="(scope.row.orderSatus==8||scope.row.orderSatus==29||scope.row.orderSatus==9)&&scope.row.serviceFeeStatus==1">(待收取服务费)</span>
						{{scope.row.orderSatus==7&&scope.row.status!=60?"(可续费)":''}}
<!--						<div class="time-line">-->
<!--							<div class="count">{{ getStatus(scope.row.orderSatus,scope.row.equipmentModel) }}</div>-->
<!--						</div>-->
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作" prop="desc">
					<template scope="{row}">
						<div class="btns">
							<span class="btn" @click="handleDetail(row)">查看</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex; justify-content: center;margin-top: 20px;" v-if="total > query.pageSize">
				<el-pagination background layout="prev, pager, next,total" :total="total" :page-size="query.pageSize"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</layout>
</template>

<script>
	import layout from './index.vue'
	import {
		orderListApi,
		orderDelApi
	} from '../../http/api/ordinary.js'
	import {getButtonSizeApi} from "@/http/factory/add-eme";
	export default {
		name: 'leaveMessage',
		components: {
			layout
		},
		data() {
			return {
				buttonSize:[],
				queryParams:{
					projectname:null,
				},

				activeTab: '全部状态',
				tabs: [{
						label: "全部状态",
						status: null,
					},
					{
						label: "未提交申请",
						status: 0
					},
					{
						label: "待厂商确认",
						status: 1
					},
					{
						label: "待平台签约",
						status: 2
					},
					{
						label: "待客户支付租金",
						status: 3
					},
					{
						label: "待厂商确认收款并发货",
						status: 4
					},
					{
						label: "待客户收货",
						status: 6
					},
					{
						label: "待厂商确认用电完成",
						status: 7
					},
					{
						label: "待客户确认用电完成",
						status: 11
					},
					{
						label: "待平台出具结算单",
						status: 18
					},
					{
						label: "待厂商结算",
						status: 28
					},
					{
						label: "待客户收款",
						status: 29
					},
					{
						label: "已完成",
						status: 8
					},
					{
						label: "已评价",
						status: 9
					},
					{
						label: "待厂商确认续费",
						status: 60
					},
					{
						label: "待平台收服务费",
						status: 71
					},
					{
						label: "中止订单",
						status: 70
					}
				],
				tableData: [],
				query: {
					orderType: 1,
					pageSize: 15,
					pageNum: 1,
					orderSatus: null,
					superType: 0
				},
				total: 0
			}
		},
		created() {
			this.getOrderList()
		},
		methods: {
			count(index) {
				return (this.query.pageNum - 1) * this.query.pageSize + index + 1
			},
			handleDetail(row) {
				console.log(row)
				this.$router.push({
					path: '/orderDetail/powerDetail',
					query: {
						id: row.id
					}
				})
			},
			getOrderList1(){
				this.query.pageNum=1;
				this.getOrderList();
			},
			getButtonSize(){
				getButtonSizeApi({
					orderType: 1,
					superType: 0,
					projectname:this.queryParams.projectname,
				}).then(response=>{
					// console.log(response)
					this.buttonSize=response;
				})
			},
			getOrderList() {
				this.query.projectname=this.queryParams.projectname;
				orderListApi(this.query).then(res => {
					this.tableData = res.rows

					for (var i = 0; i < this.tableData.length; i++) {
						if(this.tableData[i].paymentVoucher===null){
							this.tableData[i].vArray=0;
						}else{
							this.tableData[i].vArray=this.tableData[i].paymentVoucher.split(',').length;
						}
					}
					this.total = res.total
				})
				this.getButtonSize()
			},
			getStatus(status, equipmentModel) {
				for (let item of this.tabs) {
					if (status == 28) {
						if (equipmentModel == 1) {
							return '已完成'
						} else {
							return '已结算（待确认收款）'
						}
					}
					if (item.status == status) {
						return item.label
					} else if (status == 34) {
						return '服务费已支付（待平台确认）'
					}
				}
			},
			handleCurrentChange(val) {
				this.query.pageNum = val;
				this.getOrderList();
			},
			statusChange(item) {
				this.activeTab = item.label
				this.query.orderSatus = item.status
				this.getOrderList()
			},
			deleteHandle(row) {
				this.$confirm('您确定要删除当前订单吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					orderDelApi({
						id: row.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getOrderList()
					})

				})
			},
			statusChange(item) {
				this.activeTab = item.label
				this.query.orderSatus = item.status
				this.getOrderList()
			}
		}
	}
</script>
<style lang="less" scoped>
	.btnGroup {
		//border-bottom: 1px solid #F4F4F4;
		padding: 0 .4rem .2rem;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;

		.btnTab {
			margin-top: .2rem;
			margin-right: 20px;
			padding: .06rem .19rem;
			border-radius: .06rem;
			text-align: center;
			line-height: .2rem;
			font-size: 15px;
			background: #EBEBEB;
			color: #7D7D7D;
			cursor: pointer;

			&.active {
				color: #FFF;
				background: #818181;
			}
		}

	}

	.deviceTable {
		padding: 10px 20px;
		box-sizing: border-box;
		min-height: calc(100vh - 2.5rem);
	}

	.deviceCard {
		padding-right: 1rem;
		padding-top: .48rem;
		box-sizing: border-box;
		display: flex;
	}

	.row-merge {
		padding: .18rem .33rem 0;
		display: flex;
		flex-wrap: wrap;

		&.order-row0 {
			background: #F2F2F2;
		}

		.order-item {
			width: 2.3rem;
			padding-bottom: .18rem;
			display: inline-flex;
			align-items: center;
		}

		.order-name {
			padding: 0 .18rem;
			font-size: .14rem;
			color: #000;
		}
	}

	.logo {
		width: .38rem;
		min-width: .38rem;
		height: .38rem;
		border-radius: .07rem;
	}

	.nameBox {
		display: flex;
		align-items: center;

		.orderName {
			line-height: .38rem;
			padding-left: .14rem;
			color: #000;
			font-size: .14rem;
		}
	}

	.btns {
		.btn {
			padding: 0 .16rem;
			color: #000;
			cursor: pointer;

			&.error {
				color: #F53232;
			}
		}
	}

	.time-line {
		.count {
			line-height: .2rem;
			padding-bottom: .09rem;
		}

		.status {
			color: #FF6B4A;
		}
	}

	/deep/ th .cell,
	/deep/ tr .cell {
		color: #000;
		font-size: .14rem;
		font-weight: 500;
	}

	/deep/ .el-table__row {
		border-radius: .06rem;
	}

	/deep/ .warning-row {
		background: #F2F2F2;
		border-radius: .06rem;
	}

	/deep/ .el-table__expanded-cell {
		padding: 0;
	}

	/deep/ .el-table td.el-table__cell,
	/deep/ .el-table th.el-table__cell.is-leaf {
		border-bottom: unset;
	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
